import { Fragment } from "react"
import { useFieldArray, useFormContext } from "react-hook-form"
import toast from "react-hot-toast"
import { useLocation } from "react-router-dom"
import { useToggle } from "utils"
import { BillServiceValues } from "../types"
import { ListSection } from "./ListSection"
import { TableListForm } from "./TableListForm"

type TableFormBodyProps = {
  disable?: boolean
}

export const TableFormBody = ({ disable }: TableFormBodyProps) => {
  const location = useLocation()
  const stateData = useToggle(Boolean(location.state))

  const { control } = useFormContext<BillServiceValues>()
  const { fields, append, remove } = useFieldArray({ control, name: "details" })

  return (
    <Fragment>
      {fields.map((field, index) => (
        <ListSection
          disable={disable}
          key={field.id}  
          index={index}
          onDelete={() => remove(index)}
        />
      ))}

      <TableListForm
        disable={disable}
        getFromState={stateData.isActive}
        onCreate={(value) => {
          if (fields.find(item => item.product_id === value.product_id)) {
            return toast.error("The product has already on the detail list")
          }

            append(value)

          if (stateData.isActive) {
            stateData.setActive(false)
          }
        }}
      />
    </Fragment>
  )
}